import React from 'react';
import { ExternalLink } from 'lucide-react';

const partners = [
  {
    name: 'Installux',
    logo: '/logo-installux.png',
    url: 'https://installux-aluminium.com/fr',
    description: 'Fournisseur premium aluminium'
  },
  {
    name: 'Schüco',
    logo: '/logo-schueco.png',
    url: 'https://www.schueco.com/fr',
    description: 'Leader mondial fenêtres & façades'
  }
];

const Partners = () => {
  return (
    <section id="partenaires" className="py-16 md:py-24 bg-white" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-3 gap-10 md:gap-12 items-center">
          <div>
            <p className="text-[#1F6FD6] font-display font-bold text-sm uppercase tracking-[0.3em] mb-3">Matériaux premium</p>
            <h2 className="text-4xl sm:text-5xl font-black text-[#01162D] mb-5 tracking-tight">
              Nos <span className="text-[#1F6FD6]">Partenaires</span>
            </h2>
            <div className="w-20 h-1 bg-[#1F6FD6] mb-6"></div>
            <p className="text-base md:text-lg text-[#647A97] mb-8">
              Nous travaillons avec les meilleurs fournisseurs européens pour des menuiseries durables et performantes.
            </p>
            <div className="inline-flex items-center gap-3 bg-[#01162D] text-white px-5 py-3 rounded-md">
              <span className="w-2.5 h-2.5 rounded-full bg-[#3B8BEF]"></span>
              <p className="text-sm font-semibold uppercase tracking-wider">Réalisations 100% françaises</p>
            </div>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
            {partners.map((partner) => (
              <a
                key={partner.name}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#EEF1F5] p-6 md:p-10 rounded-md border border-transparent hover:border-[#1F6FD6] hover:bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
                data-testid={`partner-${partner.name.toLowerCase().replace('ü', 'u')}`}
              >
                <div className="h-24 flex items-center justify-center mb-5">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} - Partenaire SMA CONCEPT`}
                    loading="lazy"
                    className="max-h-20 w-auto object-contain"
                  />
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-[#647A97] text-sm font-medium">{partner.description}</p>
                  <ExternalLink size={16} className="text-[#647A97] group-hover:text-[#1F6FD6] transition-colors" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
